export function fez(options) {
	// DOM Ready
	document.addEventListener(
		"DOMContentLoaded",
		function() {
			// Declare top event
			var fezTop = document.createEvent("Event");
			fezTop.initEvent("fezTop", true, true);

			// Declare not top event
			var fezNotTop = document.createEvent("Event");
			fezNotTop.initEvent("fezNotTop", true, true);

			// Declare direction event
			var fezDirection = document.createEvent("Event");
			fezDirection.initEvent("fezDirection", true, true);

			// Set up the variables
			var body = document.body,
				otherElements = document.body.querySelectorAll(
					options.additionalElements
				),
				elements = [body],
				classes = {
					top: "fez-top",
					notTop: "fez-not-top",
					up: "fez-up",
					down: "fez-down"
				};

			var lastScrollPosition = 0;

			// Add addtional elements if they exist
			if (otherElements.length) {
				for (var i = 0; i < otherElements.length; i++) {
					elements.push(otherElements[i]);
				}
			}

			// Indicate at top of page when loaded
			for (var i = 0; i < elements.length; i++) {
				elements[i].classList.add(classes.top);
			}

			// Event listener for at top of page
			document.addEventListener(
				"fezTop",
				function(e) {
					for (var i = 0; i < elements.length; i++) {
						elements[i].classList.remove(classes.top);
						elements[i].classList.add(classes.notTop);
					}
				},
				false
			);

			// Event listener for not at top of page
			document.addEventListener(
				"fezNotTop",
				function(e) {
					for (var i = 0; i < elements.length; i++) {
						elements[i].classList.remove(classes.notTop);
						elements[i].classList.add(classes.top);
					}
				},
				false
			);

			// Event listener for direction of scroll
			document.addEventListener(
				"fezTop",
				function(e) {
					for (var i = 0; i < elements.length; i++) {
						var currentScrollPosition =
							window.pageYOffset ||
							document.documentElement.scrollTop;
						if (currentScrollPosition > lastScrollPosition) {
							elements[i].classList.remove(classes.up);
							elements[i].classList.add(classes.down);
						} else {
							elements[i].classList.remove(classes.down);
							elements[i].classList.add(classes.up);
						}
					}
					lastScrollPosition =
						currentScrollPosition <= 0 ? 0 : currentScrollPosition;
				},
				false
			);

			// Scroll event listener
			window.addEventListener("scroll", function(body) {
				// Statement to toggle classes to indicate if at top of page, where the offset is defined.
				if (window.scrollY >= options.offset) {
					document.dispatchEvent(fezTop);
				} else {
					document.dispatchEvent(fezNotTop);
				}
				// Direction of scroll
				document.dispatchEvent(fezDirection);
			});
		},
		false
	);
}



//////////////////
// WEBPACK FOOTER
// /Users/steve/Code/hibau/web/app/themes/hibau/node_modules/@trepanation-pray/fez/index.js
// module id = 28
// module chunks = 0